import React, { Suspense } from 'react';

const DelayedAccountDetailsStep =
  React.lazy(() => import(/* webpackChunkName: "account-details-step.async" */ './account-details-step')
    .then(({ AccountDetailsStepWithI18n }) => ({
      default: AccountDetailsStepWithI18n,
    })));

export const DelayedAccountDetailsStepWithI18n = () => (
  <Suspense fallback={null}>
    <DelayedAccountDetailsStep />
  </Suspense>
);
